import { FormField, Input } from '@amzn/awsui-components-react'
import { PROJECT_NAME_VALIDATION } from '../../Constant'

const CreateProjectTableProjectName = (props) => {
    const { id, projectName, projectNameError, onProjectNameChange } = props

    return (
        <FormField errorText={projectNameError}>
            <Input
                value={projectName}
                onChange={({ detail }) => {
                    const value = detail.value
                    let errorMessage = value.trim().length === 0 ? PROJECT_NAME_VALIDATION : ''
                    // backend will handle duplicate check against program
                    onProjectNameChange(id, 'projectNameError', errorMessage)
                    onProjectNameChange(id, 'projectName', value)
                }}
                onBlur={() => {
                    if (projectName.trim().length === 0) {
                        onProjectNameChange(id, 'projectNameError', PROJECT_NAME_VALIDATION)
                    }
                }}
                placeholder='Enter project name'
            ></Input>
        </FormField>
    )
}

export default CreateProjectTableProjectName
